/** Operator-facing labels for fleet plan / unit statuses (Bible §7/§8/§11). */

export function fleetPlanStatusLabel(status: string): string {
  switch (status) {
    case "draft":
      return "Draft";
    case "approved":
      return "Approved";
    case "published":
      return "Published";
    case "stopping":
      return "Stopping…";
    case "stopped":
      return "Stopped";
    case "completed":
      return "Completed";
    case "failed":
      return "Failed";
    case "abandoned":
      return "Abandoned";
    default:
      return status;
  }
}

/** Polish tooltip / bilingual hint for operators. */
export function fleetUnitStatusTitle(status: string): string {
  switch (status) {
    case "planned":
      return "Zaplanowane / Planned";
    case "youtrack":
      return "W YouTrack / Backlog";
    case "running":
      return "W toku / In progress";
    case "in_review":
      return "W weryfikacji / In review";
    case "paused":
      return "Wstrzymane / Paused";
    case "blocked":
      return "Zablokowane / Blocked — decision required";
    case "stopped":
      return "Zatrzymane / Stopped";
    case "done":
      return "Ukończone / Done";
    case "failed":
      return "Błąd / Failed";
    case "cancelled":
      return "Anulowane / Cancelled";
    default:
      return status;
  }
}

export function fleetAutonomyLabel(level: string | undefined): string {
  switch (level) {
    case "manual":
      return "Manual — step approval";
    case "autonomous":
      return "Autonomous — runs without asking";
    case "confirmation":
    default:
      return "Confirmation — asks before shell/merge/push; file writes free";
  }
}

export function fleetAutonomyScopeLabel(scope?: {
  tools: { files: boolean; terminal: boolean; git: boolean; browser: boolean };
}): string {
  const tools = scope?.tools;
  if (!tools) {
    return "Scope: default";
  }
  const allowed = (["files", "terminal", "git", "browser"] as const).filter((k) => tools[k]);
  return allowed.length > 0 ? `Scope: ${allowed.join(", ")}` : "Scope: none";
}

export function fleetStatusPillClass(status: string): string {
  return `pill pill--sm pill--${status.replace(/[^a-z0-9_-]/gi, "-")}`;
}

const SPAWNABLE_UNIT_STATUSES = new Set(["planned", "youtrack", "paused", "stopped"]);

/** Spawn is for queued/paused units, not terminals or blocked rows. */
export function fleetUnitSpawnAllowed(status: string): boolean {
  return SPAWNABLE_UNIT_STATUSES.has(status);
}

export function planNeedsOperatorDecision(plan: {
  requiresDecision?: boolean;
  units?: Array<{ status: string }>;
}): boolean {
  if (plan.requiresDecision === true) {
    return true;
  }
  return (plan.units ?? []).some((u) => u.status === "blocked");
}

export function planHasRunningUnits(plan: { units?: Array<{ status: string }> }): boolean {
  return (plan.units ?? []).some((u) => u.status === "running" || u.status === "in_review");
}

export function fleetPlanAgentCount(plan: { units?: Array<{ targetAgentId?: string }> }): number {
  return new Set((plan.units ?? []).map((u) => u.targetAgentId?.trim() || "planner")).size;
}

export function fleetPlanUnitCount(plan: { units?: Array<unknown> }): number {
  return (plan.units ?? []).length;
}

export function fleetUnitStatusLabel(status: string): string {
  switch (status) {
    case "planned":
      return "Planned";
    case "youtrack":
      return "Backlog";
    case "running":
      return "Running";
    case "in_review":
      return "In review";
    case "paused":
      return "Paused";
    case "blocked":
      return "Blocked";
    case "stopped":
      return "Stopped";
    case "done":
      return "Done";
    case "failed":
      return "Failed";
    case "cancelled":
      return "Cancelled";
    default:
      return status;
  }
}
